import React, { useState } from "react";
import { View, Text, TouchableOpacity } from "react-native";
import Colors from "../../../../Resources/Color";

export const DeleteConfirmationView = ({
  deleteTitle,
  deleteText,
  onCancel,
  onConfirm,
  t,
  isMobile,
}) => {
  const [cancelHovered, setCancelHovered] = useState(false);
  const [deleteHovered, setDeleteHovered] = useState(false);

  return (
    <View
      style={{
        padding: 20,
        gap: 16,
      }}
    >
      <Text
        style={{
          fontSize: 16,
          fontWeight: "600",
          color: Colors.blackColor,
        }}
      >
        {deleteTitle}
      </Text>
      <Text
        style={{
          fontSize: 13,
          color: Colors.blackColor,
          lineHeight: 18,
        }}
      >
        {deleteText}
      </Text>

      <View
        style={{
          flexDirection: "row",
          gap: 10,
          justifyContent: "flex-end",
          marginTop: 8,
        }}
      >
        <TouchableOpacity
          onPress={() => {
            setCancelHovered(false);
            onCancel?.();
          }}
          onMouseEnter={() => !isMobile && setCancelHovered(true)}
          onMouseLeave={() => !isMobile && setCancelHovered(false)}
          style={{
            paddingHorizontal: 16,
            paddingVertical: 8,
            borderRadius: 12,
            borderColor: cancelHovered
              ? Colors.darkgrayColor
              : Colors.grayColor,
            backgroundColor: cancelHovered ? Colors.hoveredGray : "transparent",
            outlineStyle: "none",
            borderWidth: 1,
            transition: "all 0.15s ease",
          }}
        >
          <Text
            style={{
              fontSize: 13,
              fontWeight: "500",
              color: Colors.darkgrayColor,
            }}
          >
            {t("cancel-string")}
          </Text>
        </TouchableOpacity>

        <TouchableOpacity
          onPress={() => {
            setDeleteHovered(false);
            onConfirm?.();
          }}
          onMouseEnter={() => !isMobile && setDeleteHovered(true)}
          onMouseLeave={() => !isMobile && setDeleteHovered(false)}
          style={{
            paddingHorizontal: 16,
            paddingVertical: 8,
            borderRadius: 12,
            backgroundColor: Colors.redColor,
            opacity: deleteHovered ? 0.92 : 1,
            outlineStyle: "none",
            transition: "opacity 0.15s ease",
          }}
        >
          <Text
            style={{
              fontSize: 13,
              fontWeight: "500",
              color: Colors.whiteColor,
            }}
          >
            {t("delete-string")}
          </Text>
        </TouchableOpacity>
      </View>
    </View>
  );
};
